<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1">
        <span slot="tab">
          <g-wiki keyValue="WIKI_AUSENTISMO"/>
          AUSENTISMO
        </span>
        <g-master name="absen"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :beforeSend="master.beforeSend"
                  modalWidth="95%"
                  ref="master"
                  :useMultipart="true"
                  @action="masterAction"
                  :actions="master.actions"
                  @params="paramsTable"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
          <template slot="expandedRowRender" slot-scope="{text}">
            <template v-for="ve in master.valoresExpandidos">
              {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
            </template>
          </template>
          <span slot="estadoRenderer" slot-scope="{text}">
                        <a-tag
                          :color="text==='CERRADA' ? 'red' : (text === 'ACTIVA' ? 'blue' : 'blue')">{{text}}</a-tag>
          </span>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Empleado')"
                          :formItemConfig="fiOptions"
                          :selectedObj.sync="empleadoseleccionado"
                          endpoint="empleados_en_reqliquidacion"
                          ref="empleado"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="absen_type"
                            style="width: 100%"
                            :label="$t('Tipo ausentismo')"
                            :formItemConfig="fiOptions"
                            :selectedObj.sync="absenSeleccionado"
                            :decorator="['abs_type', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha inicial')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD 00:00:00"
                                 v-decorator="['abs_initial', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Días ausentismo')">
                  <a-input-number :min="0" :max="9999999" v-bind="fiOptions"
                                  style="width: 100%"
                                  v-decorator="['abs_days', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha final')">
                  <a-date-picker style="width: 100%"
                                 disabled
                                 type="date"
                                 valueFormat="Y-MM-DD 00:00:00"
                                 v-decorator="['abs_end', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown v-bind="fiOptions"
                            endpoint="hierarchy_lookup"
                            :label="$t('Estado')"
                            :disabled="inactiveStatus"
                            :formItemConfig="fiOptions"
                            :decorator="['abs_status', { rules: [{ required: true, message: 'Valor requerido' }], initialValue: 'ACT' }]"
                            :params="status">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Núm. ausentismo')">
                  <a-input
                    style="width: 100%"
                    v-decorator="['abs_number', { rules: [{ required: false }]}]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Diagnóstico')"
                          :formItemConfig="fiOptions"
                          endpoint="diag"
                          ref="diagnostico"
                          :decorator="['id_diag', { rules: [{ required: requiredDiag, message: 'Valor requerido'}] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('ID aus. prórroga')"
                            :formItemConfig="fiOptions"
                            endpoint="absen"
                            :params="absenSeleccionadoParam"
                            :cache="false"
                            :decorator="['id_absen_prg', { rules: [{ required: false}] }]">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown v-bind="fiOptions"
                            endpoint="legal_entities"
                            :label="$t('Entidad')"
                            :formItemConfig="fiOptions"
                            :decorator="['ent_id', { rules: [{ required: validaRequeridoEntidad, message: 'Valor requerido'}] }]"
                            :params="parametrosPersonaPorEntidad"
                            ref="entidad"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Autorización')">
                  <a-input
                    style="width: 100%"
                    v-decorator="['abs_authorization', { rules: [{ required: false }]}]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Val. ausentismo')">
                  <a-input-number v-bind="fiOptions" style="width: 100%"
                                  v-decorator="['abs_value', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Comentarios')">
                  <a-textarea autoSize
                              v-decorator="['abs_comments', { rules: [{ required: false}] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Subir archivo')">
                  <a-upload
                    name="profile_file"
                    :before-upload="beforeUpload"
                    :fileList="master.uploads.profileFile"
                    :remove="() => { master.uploads.profileFile = [] }">
                    <a-button style="width: 100%">Seleccionar archivo</a-button>
                  </a-upload>
                </a-form-item>
              </a-col>
            </a-row>
            <a-card v-if="verCar">
              <a-alert
                message="Advertencia"
                :description="error"
                type="warning"
                show-icon
              />
            </a-card>
          </template>
        </g-master>
        <a-tabs defaultActiveKey="2">
          <a-tab-pane tab="Detalle de ausentismo" key="2">
            <absen-liq v-if="idForm" :abs_id="idForm.abs_id"></absen-liq>
            <span v-else>Seleccione un ausentismo para ver más.</span>
          </a-tab-pane>
          <a-tab-pane tab="Recuperación de cartera" key="1">
            <absen-gestion v-if="idForm" :absen="idForm"></absen-gestion>
            <span v-else>Seleccione un ausentismo para ver más.</span>
          </a-tab-pane>
        </a-tabs>
      </a-tab-pane>
    </a-tabs>
    <template>
      <a-modal v-model="visible" title="Tiempo límite" :footer="null">
        <a-result status="warning"
                  title="La fecha de Novedad ha caducado para el Calendario de Nomina Activo, por favor consulte su administrador HRO">
          <template #extra>
            <a-button @click="handleOk" type="primary">
              Cerrar
            </a-button>
          </template>
        </a-result>
      </a-modal>
    </template>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        fileNameExcel: 'ausentismo',
        paramsT: {},
        endpointExcel: 'ausentismo/downloadExcel',
        inactiveStatus: false,
        visible: false,
        requiredDiag: false,
        empleadoseleccionado: {},
        parametrosPersonaPorEntidad: {legal_entities_por_usuario: true, id_empleado: ''},
        absenSeleccionado: {},
        fecha_inicio: null,
        abs_type: null,
        dias: null,
        loadingBtns: {},
        status: {
          h_lookup_type: 'ESTADO_NOVEDAD',
          use_code: true
        },
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          actions: [],
          valoresExpandidos: [
            {label: 'ID ausentismo prórroga', column: 'id_absen_prg'},
            {label: 'Autorización', column: 'abs_authorization'},
            {label: 'Valor del ausentismo', column: 'abs_value'},
            {label: 'Comentarios', column: 'abs_comments'}
          ],
          endpoint: 'absen',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    if (this.$userIsInrol('Query')) {
                      return false
                    }
                    if (record.abs_status === 'ACT' && (this.$userIsInrol('RightHand') ||
                      this.$userIsInrol('Management') ||
                      this.$userIsInrol('AdminNomina') ||
                      this.$userIsInrol('TecniNomina') ||
                      this.$store.state.userInfo.name === record.created_by)) {
                      return true
                    }

                    if (record.abs_status === 'CER' && (this.$userIsInrol('RightHand') ||
                      this.$userIsInrol('Management') ||
                      this.$userIsInrol('AdminNomina') ||
                      this.$userIsInrol('TecniNomina'))) {
                      return true
                    }
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    if (record.abs_status === 'CER' || this.$userIsInrol('Query')) {
                      return false
                    }
                    if (record.abs_status === 'ACT' && (this.$userIsInrol('RightHand') ||
                      this.$userIsInrol('Management') ||
                      this.$userIsInrol('AdminNomina') ||
                      this.$userIsInrol('TecniNomina') ||
                      record.created_by === this.$store.state.userInfo.name)) {
                      return true
                    }
                  }
                },
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.file_name
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.abs_id] === record.abs_id
                  }
                }
              ]
            },
            customSlots: ['expandedRowRender', 'estadoRenderer'],
            tableConfig: {
              rowKey: 'abs_id'
            },
            id_emp: '',
            columns: [
              {title: '#', dataIndex: 'abs_id', sorter: true},
              {title: 'ID del empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre completo', dataIndex: 'nombre_empleado', sorter: true},
              {title: 'Cód aus', dataIndex: 'abs_type', sorter: true},
              {title: 'F. inicio', dataIndex: 'abs_inicial', sorter: true},
              {title: 'Días. aus', dataIndex: 'abs_days', sorter: true},
              {title: 'F. fin', dataIndex: 'abs_final', sorter: true},
              {title: 'T. ausentismo', dataIndex: 'tipo_abs', sorter: true},
              {title: 'ID diagnóstico', dataIndex: 'id_diag', sorter: true},
              {title: 'Diagnóstico', dataIndex: 'diag_desc', sorter: true},
              {title: 'ID entidad', dataIndex: 'ent_id', sorter: true},
              {title: 'Entidad', dataIndex: 'ent_name', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                fixed: 'right',
                sorter: true,
                width: 110,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              }
            ]
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'abs_type'},
            {name: 'abs_initial'},
            {name: 'abs_days'},
            {name: 'abs_end'},
            {name: 'abs_status'},
            {name: 'abs_number'},
            {name: 'id_diag'},
            {name: 'id_absen_prg'},
            {name: 'ent_id'},
            {name: 'abs_authorization'},
            {name: 'abs_value'},
            {name: 'abs_comments'}
          ],
          uploads: {
            profileFile: []
          },
          beforeSend: (data) => {
            if (this.master.uploads.profileFile.length > 0) {
              data.profileFile = this.master.uploads.profileFile[0]
            }
            return data
          }
        },
        id_emp: null,
        isEdit: null,
        verCar: false,
        error: ''
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.limiteRegistroNovedad()
    },
    methods: {
      objectoEmpleadoSeleccionado () {
        let emp = ''
        if (!JsUtils.isEmpty(this.empleadoseleccionado)) {
          if (!JsUtils.isEmpty(this.empleadoseleccionado.value)) {
            emp = this.empleadoseleccionado.value
            this.id_emp = emp
            this.parametrosPersonaPorEntidad = {legal_entities_por_usuario: true, id_empleado: emp}
          }
        }
      },
      masterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.master.uploads.profileFile = []
        }

        switch (action.action) {
          case 'masterCreate':
            this.verCar = false
            this.isEdit = false
            this.id_emp = null
            this.abs_type = null
            this.$refs.master.modal.form.setFieldsValue({
              id_emp: undefined
            })
            break
          case 'fieldsChange':
            if (!JsUtils.isEmpty(action.changedFields) && !JsUtils.isEmpty(action.changedFields.abs_type)) {
              this.abs_type = action.changedFields.abs_type.value
              if (!JsUtils.isEmpty(this.abs_type) && !JsUtils.isEmpty(this.fecha_inicio)) {
                this.calculaFechaFin(this.abs_type, this.fecha_inicio, this.dias)
              }
            }
            if (!JsUtils.isEmpty(action.changedFields) && !JsUtils.isEmpty(action.changedFields.abs_initial)) {
              this.fecha_inicio = action.changedFields.abs_initial.value
              if (!JsUtils.isEmpty(this.fecha_inicio)) {
                if (!JsUtils.isEmpty(this.abs_type)) {
                  this.calculaFechaFin(this.abs_type, this.fecha_inicio, this.dias)
                }

                if (this.$getConfigValue('MOSTRAR_ALERTA_VALI_FECHA_INI_NOV_VS_FECHA_INI_EMP', 'NO') === 'SI') {
                  if (!JsUtils.isEmpty(this.id_emp)) {
                    this.validarFechaIniNov(this.id_emp, this.fecha_inicio)
                  }
                }
              }
            }
            if (!JsUtils.isEmpty(action.changedFields) && !JsUtils.isEmpty(action.changedFields.abs_days)) {
              this.dias = action.changedFields.abs_days.value
              if (!JsUtils.isEmpty(this.abs_type) && !JsUtils.isEmpty(this.fecha_inicio)) {
                this.calculaFechaFin(this.abs_type, this.fecha_inicio, this.dias)
              }
            }
            break

          case 'download':
            this.downloadFile(action.record)
            break

          case 'masterEdit':
            this.verCar = false
            this.isEdit = true
            this.id_emp = action.record.id_emp
            this.abs_type = action.record.abs_type
            this.empleadoseleccionado = {value: action.record.id_emp}
            this.objectoEmpleadoSeleccionado()
            this.inactiveStatus = action.record.estado === 'CERRADA'
            this.$nextTick(() => {
              if (!JsUtils.isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
              if (!JsUtils.isEmpty(action.record.id_coc)) {
                this.$refs.concepto && this.$refs.concepto.handleSearch(action.record.id_coc)
              }
              if (!JsUtils.isEmpty(action.record.id_diag)) {
                this.$refs.diagnostico && this.$refs.diagnostico.handleSearch(action.record.id_diag)
              }
              if (!JsUtils.isEmpty(action.record.ent_id)) {
                this.$refs.entidad && this.$refs.entidad.handleChange(action.record.ent_id)
              }
            })
            break
        }
      },
      handleOk () {
        this.visible = false
      },
      downloadFile (record) {
        this.loadingBtns[record.abs_id] = record.abs_id
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('absen/download', {
          abs_id: record.abs_id
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.abs_id]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.master.uploads.profileFile = [file]
        }
        return false
      },
      validateFile (file) {
        const array = ['application/pdf', 'image/jpeg', 'text/html', 'text/plain']
        const isJpgOrPng = file.type
        if (!array.includes(isJpgOrPng)) {
          this.$message.error('Solo se pemiten documentos pdf, jpeg o jpg, texto plano o html')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      },
      limiteRegistroNovedad () {
        if (this.$userIsInrol('RightHand') || this.$userIsInrol('Management') || this.$userIsInrol('AdminNomina')) {
          this.master.actions.push({
            name: 'masterCreate',
            text: 'Crear',
            permisos: [],
            fnVisible: () => !this.$userIsInrol('Query'),
            props: {icon: 'plus', type: 'button'}
          })
        } else {
          this.httpClient.getInstance().get('tiempo_limite')
            .then(response => {
              if (response.data[0].tiempolimite !== '1') {
                this.visible = true
                this.master.actions.splice(0)
              } else {
                this.master.actions.push({
                  name: 'masterCreate',
                  text: 'Crear',
                  permisos: [],
                  fnVisible: () => !this.$userIsInrol('Query'),
                  props: {icon: 'plus', type: 'button'}
                })
              }
            })
            .catch(() => {
              Mensajes.error('Error', 'No fue posble cargar el tiempo límite para registrar una novedad')
            })
        }
      },
      calculaFechaFin (absType, fechaInicio, dias) {
        this.httpClient.getInstance().post('calcula_fecha_fin', {
          id_absen_type: absType,
          date_ini: fechaInicio,
          abs_days: dias
        })
          .then((response) => {
            this.$refs.master.modal.form.setFieldsValue({
              abs_end: response.data
            })
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible calcular la fecha fin.')
            this.error = true
          })
      },
      paramsTable (params) {
        this.paramsT = params
      },
      validarFechaIniNov (idEmp, fechaIni) {
        this.httpClient.getInstance().post('validar_fecha_ini_nov', {
          id_emp: idEmp,
          fecha_inicio: fechaIni
        })
          .then((response) => {
            if (parseInt(response.data) !== 0) {
              this.verCar = true
              this.error = response.data
            } else {
              this.verCar = false
            }
          })
          .catch((error) => {
            this.verCar = true
            this.error = this.$getErrorMessage(error, 'No fue posible validar la fecha inicial, contacte al administrador.')
          })
      }
    },
    computed: {
      validaRequeridoEntidad () {
        return this.$getConfigValue('AUSENTISMOS_CAMPO_ENTIDAD_REQUERIDO', null) === 'SI'
      },
      idForm () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      },
      absenSeleccionadoParam () {
        let absType = ''
        if (!this.$isEmpty(this.absenSeleccionado) && !this.$isEmpty(this.absenSeleccionado.value) &&
          ((!this.$isEmpty(this.empleadoseleccionado) && !this.$isEmpty(this.empleadoseleccionado.value)) ||
            !this.$isEmpty(this.id_emp))) {
          absType = this.absenSeleccionado.value
          return {abs_type: absType, id_empleado: this.id_emp}
        }
        if (this.isEdit) {
          return {abs_type: this.abs_type, id_empleado: this.id_emp}
        }
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    },
    watch: {
      empleadoseleccionado () {
        this.objectoEmpleadoSeleccionado()
      },
      absenSeleccionado () {
        if (this.$getConfigValue('VALIDAR_CAMPO_DIAGNOSTICO') === 'SI') {
          this.requiredDiag = this.absenSeleccionado.text === '7 ENFERMEDAD GENERAL' || this.absenSeleccionado.text === '8 ACCIDENTE DE TRABAJO'
        }
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/Absen.vue